import React from "react";
import { HStack, Icon, Text, VStack } from "@chakra-ui/react";
import TinyHeading from "components/TinyHeading";

export interface WalletAssetProps {
  title: React.ReactNode;
  icon: React.FC;
  value?: string | number | JSX.Element;
}

const WalletAsset: React.FC<WalletAssetProps> = ({ title, icon, value }) => {
  return (
    <VStack
      align="flex-start"
      bg="dark.400"
      px={4}
      py="3.5"
      gap="0.5"
      w="full"
      overflow="hidden"
    >
      <TinyHeading>{title}</TinyHeading>

      <HStack justify="stretch" overflow="hidden" w="full">
        <Icon as={icon} w="7" h="auto" color="secondary.500" />
        <Text fontSize="2xl" lineHeight="6" isTruncated>
          {value ?? "–"}
        </Text>
      </HStack>
    </VStack>
  );
};

export default WalletAsset;
